import { render, staticRenderFns } from "./ViTeacherAcademicManagementExamResult.vue?vue&type=template&id=fe5e6bb4"
import script from "./ViTeacherAcademicManagementExamResult.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementExamResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports